import { $menuOpen, $lastFocusedElement, toggleMenu as storeToggleMenu } from '../_store.js';
import * as focusTrap from 'focus-trap';
class SectionMenu extends HTMLElement {
  constructor() {
    super();
    this.firstFocusTarget = this.querySelectorAll('a, button')?.[0];
    this.otherFocusTarget = document.querySelector('.s-header');
  }
  connectedCallback() {
    this.trap = focusTrap.createFocusTrap([this, this.otherFocusTarget], {
      allowOutsideClick: true,
      clickOutsideDeactivates: true,
      initialFocus: this.firstFocusTarget || undefined,
      escapeDeactivates: false
    });
    // store events
    $menuOpen.subscribe(value => {
      this.handleToggle(value);
    });
    // listen to the esc key in a way that the listner can be then removed in disconectedCallback
    this.bndHandleEscape = this.handleEscape.bind(this);
    document.addEventListener('keydown', this.bndHandleEscape);
  }
  disconnectedCallback() {
    document.removeEventListener('keydown', this.bndHandleEscape);
  }
  handleEscape(e) {
    if ($menuOpen.get() && e.key === 'Escape') {
      storeToggleMenu(false);
    }
  }
  handleToggle(value) {
    if (value) {
      this.removeAttribute('hidden');
      this.trap.activate();
    } else {
      const lastFocusedElement = $lastFocusedElement.get();
      this.setAttribute('hidden', true);
      this.trap.deactivate();
      lastFocusedElement?.focus();
    }
  }
}
customElements.define('section-menu', SectionMenu);